export default __webpack_public_path__ + "static/media/AssignDriverImage.04fbdb8e.svg";